module.exports = __webpack_public_path__ + "static/media/WarningTone.584a737a.wav";